// extracted by mini-css-extract-plugin
export var body = "_3l-1";
export var bodyPadded = "_3l-2";
export var chevron = "_3l-4";
export var chevronOpen = "_3l-5";
export var header = "_3l-0";
export var icon = "_3l-3";